import React, { Component } from 'react';
import BuildListItem from './build-list-item'
import LinearProgress from 'material-ui/LinearProgress';
import Divider from 'material-ui/Divider';
import CircularProgress from 'material-ui/CircularProgress';
import navList from '../data/nav.json';
import BuildList from '../components/build-list'
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { fade } from 'material-ui/utils/colorManipulator';
import MenuBar from './app-bar'
import {
  blue500,
  blue700,
  blueGrey100,
  blueGrey500,
  darkBlack,
  grey300,
  lightBlack,
  purpleA200,
  lightGreen900,
  lime500,
  deepOrange500,
  lightGreenA400,
  lightGreen500,
  white
} from 'material-ui/styles/colors';
import App from '../App';



const styles = {
    iconStyles: {
      marginRight: 24,
    }
  };
  
  const muiTheme = getMuiTheme({
    spacing: {
      iconSize: 24,
      desktopGutter: 24,
      desktopGutterMore: 32,
      desktopGutterLess: 16,
      desktopGutterMini: 8,
      desktopKeylineIncrement: 64,
      desktopDropDownMenuItemHeight: 32,
      desktopDropDownMenuFontSize: 15,
      desktopLeftNavMenuItemHeight: 48,
      desktopSubheaderHeight: 48,
      desktopToolbarHeight: 56,
    },
    fontFamily: 'Roboto, sans-serif',
    palette: {
      primary1Color: blue500,
      primary2Color: blue700,
      primary3Color: lightBlack,
      accent1Color: purpleA200,
      accent2Color: blueGrey100,
      accent3Color: blueGrey500,
      textColor: darkBlack,
      alternateTextColor: white,
      canvasColor: white,
      borderColor: grey300,
      disabledColor: fade(darkBlack, 0.3),
      pickerHeaderColor: blue500,
      backCanvas: {
        viewportBackgroundColor: white,
        navDrawerBoxShadow: true
      },
    },
    avatar: {
      borderColor: white,
    },
  });

class Builds extends Component {
    builds = [];
    config = {};
    path = "";

    constructor(props) {        
        super(props);           
        var isLoggedIn = false; 
        var time = parseInt(localStorage.getItem("auth_expiry"));    
        if(!isNaN(time)){    
            if(Math.abs(time - Date.now())/36e5 > 1){          
              localStorage.clear(); 
            }
          else{
            isLoggedIn = true;
          }
        }
        this.getConfig(location.pathname);        
        this.state = {showProgressIndicator : true, open : false, config : this.config, isLoggedIn : isLoggedIn}    
        this.builds = this.getBuilds(location.pathname.substring(1));   
        this.path = location.pathname; 
        
    }       

    componentWillReceiveProps(nextProps){
      var isLoggedIn = false; 
      var time = parseInt(localStorage.getItem("auth_expiry"));    
      if(!isNaN(time)){    
          if(Math.abs(time - Date.now())/36e5 > 1){          
            localStorage.clear(); 
          }
        else{
          isLoggedIn = true;
        }
        
      }
      this.path = location.pathname        
      this.config = this.getConfig(location.pathname); 
      console.log(this.config);
      this.state = {showProgressIndicator : true, open : false, config : this.config, isLoggedIn : isLoggedIn};      
      this.getBuilds(nextProps.location.pathname.substring(1));          
    }

    getConfig = (path) => {     
      var test = {};           
        navList.forEach(item => {
           item.Branch.forEach(item1 => {
               if(item1.Prefix.toLowerCase() === path.substring(1).toLowerCase()){
                    this.config = item1;
                    if(this.state){
                      this.config = item1;
                      test = item1;                                         
                    }
                }              
           })
        });               
      return test;
    }

    getBuilds= (prefix) => {           
          //let url = `http://localhost:8081?prefix=${prefix}`;
          let url = `https://vk89870z3d.execute-api.us-east-1.amazonaws.com/prod?prefix=${prefix}`;                   
          fetch(url,
            {
              method: 'GET',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
            })  
            .then((res) => res.json())
            .then((resJson) => { 
              this.setState({
                showProgressIndicator : false,
                open: false,
                builds: resJson,
                config : this.config                                                                            
              });              
              return resJson;
            });
    }

    render() {                
        let { builds, showProgressIndicator, config } = this.state; 
        if(!this.state.isLoggedIn){
          return(              
            <MuiThemeProvider muiTheme={muiTheme}> 
             <div className="App">                                  
               <MenuBar path = {this.path}/> 
             </div>
            </MuiThemeProvider> 
               ) 
        }
        else{
          return(              
            <MuiThemeProvider muiTheme={muiTheme}> 
             <div className="App">                                  
               <MenuBar path = {this.path}/>            
               <BuildList builds={builds} config={config} showProgressIndicator={showProgressIndicator}></BuildList>            
             </div>
            </MuiThemeProvider> 
               )  
        }   
    }
}

export default Builds;


// WEBPACK FOOTER //
// ./src/components/builds.js